/******************************************************************************
 * Copyright © 2018 Apollo Foundation                                         *
 *                                                                            *
 ******************************************************************************/

import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import store from './store';
import App from './App/App';

import { createRoot } from 'react-dom/client';

const target = document.querySelector('#root');
const root = createRoot(target as Element);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path='/' component={App} />
      </Switch>
    </BrowserRouter>
  </Provider>,
);
